import React from "react";

const Testimonials = () => {
  const testimonials = [
    {
      text: "Partnering with this platform has transformed my business. The instant payments and seamless communication make every project a breeze!",
      name: "Amit Gogia",
      designation: "Gogia Prints",
      image: "/assests/images/LandingPage/vendor/img-1.png",
    },
    {
      text: "I’ve never experienced such a reliable system. From hyperlocal opportunities to quick deal closures, this platform truly delivers",
      name: "Sunny Kumar",
      designation: "Sawhney Signages",
      image: "/assests/images/LandingPage/vendor/img-2.png",
    },
    {
      text: "The dedicated support team ensures I’m always on track. It’s great to work with a platform that values both vendors and clients equally.",
      name: "Prateek Taneja",
      designation: "Adtek",
      image: "/assests/images/LandingPage/vendor/img-3.png",
    },
  ];

  return (
    <div className="bg-gray-100 py-16 px-6 md:px-16">
      <h3 className="text-center text-lg text-gray-500 uppercase tracking-wide mb-4">
        Testimonials
      </h3>
      <h2 className="text-center text-2xl font-bold mb-8">
        Encouraging Words From Vendor Partners
      </h2>
      <div className="flex flex-col md:flex-row gap-6 justify-center items-center">
        {testimonials.map((testimonial, index) => (
          <div
            key={index}
            className={`p-6 rounded-lg shadow-lg w-full max-w-sm md:max-w-md ${
              index === 1 ? "bg-gray-800 text-white" : "bg-white"
            }`}
          >
            <img 
              src="/assests/images/LandingPage/vendor/markIcon.png"
              alt="mark"
              className="w-4 h-4  mr-4 mb-4"
            />
            <p className={`text-sm mb-6 ${index === 1 ? "text-gray-300" : ""}`}>{testimonial.text}</p>
            <div className="flex items-center">
              {/* <img
                src={testimonial.image}
                alt={testimonial.name}
                className="w-12 h-12 rounded-full mr-4"
              /> */}
              <div>
                <h4 className="font-bold text-sm">{testimonial.name}</h4>
                <p className="text-xs">{testimonial.designation}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
